module.exports = __webpack_public_path__ + "static/media/Zero.86bdeb74.png";